import pimg1 from '../img/portfolio/01.png'
import pimg2 from '../img/portfolio/02.png'
import pimg3 from '../img/portfolio/03.png'
import pimg4 from '../img/portfolio/04.png'
import pimg5 from '../img/project/01.jpg'
import pimg6 from '../img/project/03.jpg'
import pimg7 from '../img/project/05.jpg'
import pimg8 from '../img/project/06.jpg'
import pimg9 from '../img/project/04.jpg'
import pimg10 from '../img/project/07.jpg'
import pimg11 from '../img/project/02.jpg'
import pimg12 from '../img/project/08.jpg'
import pimg13 from '../img/project/09.jpg'
import pimg14 from '../img/project/10.jpg'
import pimg15 from '../img/project/11.jpg'
import pimg16 from '../img/project/10.jpg'

import pS1img1 from '../img/project-details/s1.jpg'
import pS1img2 from '../img/project-details/s2.jpg'
import pS1img3 from '../img/project-details/s3.jpg'
import pS1img4 from '../img/project-details/s4.jpg'
import pS1img5 from '../img/project-details/s5.jpg'
import pS1img6 from '../img/project-details/s6.jpg'
import pS1img7 from '../img/project-details/s7.jpg'
import pS1img8 from '../img/project-details/s8.jpg'
import pS1img9 from '../img/project-details/s9.jpg'
import pS1img10 from '../img/project-details/s10.jpg'
import pS1img11 from '../img/project-details/s11.jpg'
import pS1img12 from '../img/project-details/s12.jpg'
import pS1img13 from '../img/project-details/s1.jpg'
import pS1img14 from '../img/project-details/s3.jpg'
import pS1img15 from '../img/project-details/s2.jpg'
import pS1img16 from '../img/project-details/s5.jpg'
import pS1img17 from '../img/project-details/s7.jpg'


import pS2img1 from '../img/project-details/b1.jpg'
import pS2img2 from '../img/project-details/b2.jpg'
import pS2img3 from '../img/project-details/b3.jpg'
import pS2img4 from '../img/project-details/b4.jpg'
import pS2img5 from '../img/project-details/b5.jpg'
import pS2img6 from '../img/project-details/b6.jpg'
import pS2img7 from '../img/project-details/b7.jpg'
import pS2img8 from '../img/project-details/b8.jpg'
import pS2img9 from '../img/project-details/b9.jpg'
import pS2img10 from '../img/project-details/b10.jpg'
import pS2img11 from '../img/project-details/b11.jpg'
import pS2img12 from '../img/project-details/b12.jpg'
import pS2img13 from '../img/project-details/b12.jpg'
import pS2img14 from '../img/project-details/b13.jpg'
import pS2img15 from '../img/project-details/b14.jpg'
import pS2img16 from '../img/project-details/b15.jpg'
import pS2img17 from '../img/project-details/b10.jpg'





const Portfolio = [
    {
        id: '1',
        title:'3d Genareted Cat',
        Subtitle:'AI',
        slug:'3d-Genareted-Cate',
        pimg1:pimg1,
        pS1img:pS1img1,
        pS2img: pS2img1,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '2',
        title:'Reliable quality',
        Subtitle:'AI',
        slug:'Reliable-quality',
        pimg1:pimg2,
        pS1img:pS1img2,
        pS2img: pS2img2,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '3',
        title:'Smooth automation',
        Subtitle:'AI',
        slug:'Smooth-automation',
        pimg1:pimg3,
        pS1img:pS1img3,
        pS2img: pS2img3,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '4',
        title:'Local fulfillment',
        Subtitle:'AI',
        slug:'Local-fulfillment',
        pimg1:pimg4,
        pS1img:pS1img4,
        pS2img: pS2img4,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '5',
        title:'3d Printed Cup',
        Subtitle:'AI',
        slug:'3d-Printed-Cup',
        pimg1:pimg5,
        pS1img:pS1img5,
        pS2img: pS2img5,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '6',
        title:'Painted Orange Slices',
        Subtitle:'AI',
        slug:'Painted-Orange-Slices',
        pimg1:pimg6,
        pS1img:pS1img6,
        pS2img: pS2img6,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '7',
        title:'Banana & Coffee',
        Subtitle:'AI',
        slug:'Banana-Coffee',
        pimg1:pimg7,
        pS1img:pS1img7,
        pS2img: pS2img7,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '8',
        title:'Coffee o Clock',
        Subtitle:'AI',
        slug: 'Coffee-o-Clock',
        pimg1:pimg8,
        pS1img:pS1img8,
        pS2img: pS2img8,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '9',
        title:'Cherries on Turquiose',
        Subtitle:'AI',
        slug:'Cherries-on-Turquiose',
        pimg1:pimg9,
        pS1img:pS1img9,
        pS2img: pS2img9,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '10',
        title:'Orange on Blue',
        Subtitle:'AI',
        slug:'Orange-on-Blue',
        pimg1:pimg10,
        pS1img:pS1img10,
        pS2img: pS2img10,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '11',
        title:'Orange Rose Flower',
        Subtitle:'AI',
        slug:'Orange-Rose-Flower',
        pimg1:pimg11,
        pS1img:pS1img11,
        pS2img: pS2img11,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '12',
        title:'Glasses of Cocktail',
        Subtitle:'AI',
        slug:'Glasses-of-Cocktail',
        pimg1:pimg12,
        pS1img:pS1img12,
        pS2img: pS2img12,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '13',
        slug:'Glasses-of-Cocktail1',
        pimg1:pimg13,
        pS1img:pS1img13,
        pS2img: pS2img13,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '14',
        slug:'Glasses-of-Cocktail2',
        pimg1:pimg14,
        pS1img:pS1img14,
        pS2img: pS2img14,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '15',
        slug:'Glasses-of-Cocktail3',
        pimg1:pimg15,
        pS1img:pS1img15,
        pS2img: pS2img15,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },
    {
        id: '16',
        slug:'Glasses-of-Cocktail4',
        pimg1:pimg16,
        pS1img:pS1img16,
        pS2img: pS2img16,
        date:'25 October 2024',
        location:'Design Studio In USA',
    },

]
export default Portfolio;